import { render, staticRenderFns } from "./TravelsTableBody.vue?vue&type=template&id=04833035&"
import script from "./TravelsTableBody.vue?vue&type=script&lang=js&"
export * from "./TravelsTableBody.vue?vue&type=script&lang=js&"
import style0 from "./TravelsTableBody.vue?vue&type=style&index=0&id=04833035&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports